import { createElement as h } from 'react';
import { getContext } from './getContext';
export const RouterContext = getContext();
export const Provider = ({ children, router }) => {
    return h(RouterContext.Provider, {
        value: router,
        children,
    });
};
